module.exports = __webpack_public_path__ + "img/waves-6.7792f2c9.webp";